/**
 * The Company Map half of the type-meta line: `Run by <email>`.
 *
 * Four rounds of subtraction got it from a four-row bordered card to this,
 * each one removing a fact that was already on the page somewhere better:
 *
 * - `Original contact list` and `Original search` (2026-08-25) — the parent
 *   file is named by the Full history trail, and the parent search IS the
 *   Search block beside the title. Removing the last parent prop also let
 *   `ImportDetailPage` drop a whole `GET /imports/{parent}` it fired purely to
 *   fill a duplicate row.
 * - `Matches` (2026-08-26) — on a Company Map the match count and the contact
 *   count are THE SAME NUMBER, and the contact count is already in the pager
 *   and the stats popover.
 * - `Criteria` (2026-08-26) — moved to `CriteriaBox`, a full-width row of its
 *   own, because it is the one header fact that grows without bound.
 *
 * What is left needs NO QUERY. `triggeredByEmail` comes from the import row
 * the page already has, so this component no longer touches `bct.client` at
 * all — the Company Map run is fetched once, by `CriteriaBox`, for the one
 * field that actually lives on it.
 */

export function BctRunMeta({ triggeredByEmail }: { triggeredByEmail: string | null | undefined }) {
  return (
    <span
      data-testid="bct-run-detail"
      // `text-caption` (11px). This slot used `text-body-sm`, which is NOT a
      // defined fontSize key in either tailwind config (the scale is
      // display/h1/h2/h3/body/label/caption/micro/nano) and generated no CSS —
      // and since no root `font-size` is declared anywhere, it inherited the
      // BROWSER DEFAULT of 16px rather than the 13px body it reads as.
      //
      // Changed here because cl.5 shrank the AI Review tail and would otherwise
      // have left three tails in one row at two different sizes — 11px and
      // 16px — in the component whose docstring exists to say a badge "must not
      // move by kind" (round 9, Agent A §2.3). Seven OTHER call sites in
      // `packages/web` carry the same dead class and are deliberately untouched:
      // they are not in this row and not this card's business.
      className="flex flex-wrap items-baseline gap-x-2 text-caption text-text"
    >
      <span className="text-text-secondary">Run by</span>
      <span data-testid="bct-detail-triggered-by">{triggeredByEmail ?? "—"}</span>
    </span>
  );
}
